import { Divider, Drawer, List, ListItem, ListItemIcon, ListItemText, ListSubheader, styled } from '@mui/material';
import { router } from '~/router';
import Icon from 'Components/Icon';
import { closeSidebar } from 'ducks/ui';
import PropTypes from 'prop-types';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { HEADER_HEIGHT } from 'utils/ui/constants.js';

const drawerWidth = 260;

const StyledDrawer = styled(Drawer)(() => ({
    width: drawerWidth,
    flexShrink: 0,
    '& .MuiDrawer-paper': {
        width: drawerWidth,
        position: 'relative',
        top: HEADER_HEIGHT
    }
}));

const StyledList = styled(List)({
    width: 'auto',
    overflowY: 'auto'
});

const StyledListItem = styled(ListItemIcon)({
    width: 16
});

const navigate = event => router.navigate(event.currentTarget.dataset.url);

const renderSubsection = ({ icon, text, url }) => (
    <ListItem data-url={url} key={url} onClick={navigate}>
        <StyledListItem>
            <Icon icon={icon} pull="right"/>
        </StyledListItem>
        <ListItemText primary={text}/>
    </ListItem>
);

const renderSections = sections => sections.map(({ name, subsections }, index) => (
    <React.Fragment key={index}>
        <StyledList
            dense
            subheader={<ListSubheader component="div" disableSticky>{name}</ListSubheader>}
        >
            {subsections.map(renderSubsection)}
        </StyledList>
        {index === sections.length - 1 ? null : <Divider/>}
    </React.Fragment>
));

const Sidebar = ({ sections }) => {
    const dispatch = useDispatch();
    const showSidebar = useSelector(state => state.ui.showSidebar);

    const closeBar = () => dispatch(closeSidebar());

    return (
        <StyledDrawer
            onClose={closeBar}
            onMouseLeave={closeBar}
            open={showSidebar}
        >
            <div
                onClick={closeBar}
                onKeyDown={closeBar}
                role="button"
                tabIndex={0}
            >
                <StyledList>{renderSections(sections)}</StyledList>
            </div>
        </StyledDrawer>
    );
};

Sidebar.propTypes = {
    sections: PropTypes.array.isRequired
};

export default Sidebar;
